import { render, staticRenderFns } from "./IcoSolicitud.vue?vue&type=template&id=64703829&scoped=true"
import script from "./IcoSolicitud.vue?vue&type=script&lang=ts"
export * from "./IcoSolicitud.vue?vue&type=script&lang=ts"
import style0 from "./IcoSolicitud.vue?vue&type=style&index=0&id=64703829&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64703829",
  null
  
)

export default component.exports